export { Main } from '../../ui/page-layout/main/main';
export { MainStickyHeader } from '../../ui/page-layout/main/main-sticky-header';
export {
	UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY,
	UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY,
	UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY,
} from '../../ui/page-layout/constants';
